<div mat-dialog-title class="d-flex justify-content-between align-items-center">
  <h2 class="m-0">Membership appointment details</h2>
  <button mat-icon-button mat-dialog-close>
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content>
  <div class="main_div">
     <div class="bookinght_sectiokl">
      <div class="booking_list_open">
        <div class="member_profile">
           <div class="bgt_colorkk"></div>
           <img [src]="bookingDetails.member_thumb_image" onerror="this.src='../../../../assets/images/user-avatar.svg'" alt=""/>
        </div>
        <div class="details_hhj">
           <h3> {{bookingDetails.customer_name}}</h3>
           <p> {{bookingDetails.country_code ? bookingDetails.country_code : '-'}} {{bookingDetails.customer_phone &&  bookingDetails.customer_phone != 'null' ? bookingDetails.customer_phone : '---'}}, {{bookingDetails.gender ? bookingDetails.gender : bookingDetails.gender }} </p>
        
        </div>
      </div>

      <div class="booking_list_ser">
        <div class="booki_list">
        <mat-chip-list aria-label="Fish selection" class="mb-3">
          <div *ngIf="bookingDetails.billing_cycle == 1">
             <mat-chip  style="height: auto">Weekly billing</mat-chip>
          </div>
          <div *ngIf="bookingDetails.billing_cycle == 2">
             <mat-chip  style="height: auto">Monthly billing</mat-chip>
          </div>
          <div *ngIf="bookingDetails.billing_cycle == 3">
             <mat-chip  style="height: auto">Yearly billing</mat-chip>
          </div>
       </mat-chip-list>
      </div>
        <!--  -->
        <div class="booki_list">
        <mat-chip-list aria-label="Fish selection" class="mb-3">
          <div *ngIf="bookingDetails.bookingType == 0">
            <mat-chip  style="height: auto"> Home service</mat-chip>
          </div>
          <div *ngIf="bookingDetails.bookingType == 1">
            <mat-chip  style="height: auto"> In-premise service</mat-chip>
          </div>
          <div *ngIf="bookingDetails.bookingType == 2">
            <mat-chip  style="height: auto">Virtual service</mat-chip>
          </div>
          <div *ngIf="bookingDetails.bookingType != 0 && bookingDetails.bookingType != 1 && bookingDetails.bookingType != 2">
            <mat-chip  style="height: auto"> {{bookingDetails.bookingType}}</mat-chip>
          </div>
        </mat-chip-list>
        </div>
        <!--  -->
      </div>


        <!-- <div class="service_billing_section">
           <div class="row">
              <div class="col-md-6">
                 <div class="sub_one sub_margin" style="border-right: 1px solid #ddd;">
                    <div class="sub_one_cont">
                       <div class="entity_detail make_text_grey">
                          Billing cycle	
                       </div>
                    </div>
                    <div class="sub_one_cont main_text">
                       <mat-chip-list aria-label="Fish selection" class="mb-3">
                          <div *ngIf="bookingDetails.billing_cycle == 1">
                             <mat-chip  style="height: auto">Weekly</mat-chip>
                          </div>
                          <div *ngIf="bookingDetails.billing_cycle == 2">
                             <mat-chip  style="height: auto">Monthly</mat-chip>
                          </div>
                          <div *ngIf="bookingDetails.billing_cycle == 3">
                             <mat-chip  style="height: auto">Yearly</mat-chip>
                          </div>
                       </mat-chip-list>
                    </div>
                 </div>
              </div>

              <div class="col-md-6">
                 <div class="sub_one sub_margin">
                    <div class="sub_one_cont">
                    
                       <div class="entity_detail make_text_grey">
                          Service mode
                       </div>
                    </div>
                    <div class="sub_one_cont main_text">
                     
                       <mat-chip-list aria-label="Fish selection" class="mb-3">
                          <div *ngIf="bookingDetails.bookingType == 0">
                             <mat-chip  style="height: auto"> Home service</mat-chip>
                          </div>
                          <div *ngIf="bookingDetails.bookingType == 1">
                             <mat-chip  style="height: auto"> Shop service</mat-chip>
                          </div>
                          <div *ngIf="bookingDetails.bookingType == 2">
                             <mat-chip  style="height: auto">Virtual service</mat-chip>
                          </div>
                          <div *ngIf="bookingDetails.bookingType != 0 && bookingDetails.bookingType != 1 && bookingDetails.bookingType != 2">
                             <mat-chip  style="height: auto"> {{bookingDetails.bookingType}}</mat-chip>
                          </div>
                       </mat-chip-list>
                    </div>
                 </div>
              </div>
           </div>
        </div> -->


      
           <!-- <div class="col-md-6">
              <div class="sub_one sub_margin">
                <div class="sub_one_cont">
                  <div>
                    <span class="material-icons icon_mat"> person </span>
                  </div>
                  <div class="entity_detail make_text_grey">
                     Name
                  </div>
                </div>
                <div class="sub_one_cont main_text">
                  <div class="entity_detail" >
                      {{bookingDetails.customer_name}}
                  </div>
                </div>
              </div>
              </div> -->
           <!-- <div class="col-md-6">
              <div class="sub_one sub_margin">
                <div class="sub_one_cont">
                  <div>
                    <span class="material-icons icon_mat"> call </span>
                  </div>
                  <div class="entity_detail make_text_grey">
                     Phone
                  </div>
                </div>
                <div class="sub_one_cont main_text">
                  <div class="entity_detail" >
                      {{bookingDetails.country_code ? bookingDetails.country_code : '-'}} {{bookingDetails.customer_phone &&  bookingDetails.customer_phone != 'null' ? bookingDetails.customer_phone : '---'}}
                  </div>
                </div>
              </div>
              </div> -->
           <!-- <div class="col-md-6">
              <div class="sub_one sub_margin">
                <div class="sub_one_cont">
                  <div>
                    <span class="material-icons icon_mat"> library_books </span>
                  </div>
                  <div class="entity_detail make_text_grey">
                      Gender
                  </div>
                </div>
                <div class="sub_one_cont main_text">
                  <div class="entity_detail" style="margin-left: 34px;font-size: 16px;">
                      {{bookingDetails.gender ? bookingDetails.gender : bookingDetails.gender }}
                  </div>
                </div>
              </div>
              </div> -->




              <div class="service_billing_section">
                <div class="ther_oper" >
                  <div class="sub_one sub_margin">
                     <div class="sub_one_cont">
                        <!-- <div>
                           <span class="material-icons icon_mat"> schedule </span>
                        </div> -->
                        <div class="entity_detail make_text_grey">
                           Slot timing
                        </div>
                     </div>
                     <div class="sub_one_cont main_text">
                        <!-- <div class="entity_detail" >
                           {{bookingDetails.bookingStartTime ? bookingDetails.bookingStartTime : bookingDetails.booking_start_time}} - {{bookingDetails.bookingEndTime ? bookingDetails.bookingEndTime : bookingDetails.booking_end_time}}
                        </div> -->
                        <div class="entity_detail" style="margin-bottom: 0px !important;">
                          <mat-chip-list aria-label="Fish selection" class="mb-3">
                             <div>
                                <mat-chip
                                   
                                   style="height: auto"                                                                                                                                                                                                            
                                   > {{bookingDetails.bookingStartTime ? bookingDetails.bookingStartTime : bookingDetails.booking_start_time}} - {{bookingDetails.bookingEndTime ? bookingDetails.bookingEndTime : bookingDetails.booking_end_time}}
                                </mat-chip>
                             </div>
                          </mat-chip-list>
                       </div>
                     </div>
                  </div>
               </div>
              </div>



              <div class="service_billing_section" style="padding-bottom: 0px;">
          <div class="row">
            <div class="Service_list_yy">
           <div class="col-md-12" style="padding: 0;">
              <div class="sub_one sub_margin">
                 <div class="sub_one_cont">
                 
                    <div class="entity_detail make_text_grey">
                       Service
                    </div>
                 </div>
                 <div class="sub_one_cont main_text">
                    <div class="entity_detail" style="margin-bottom: 0px !important;">
                       <mat-chip-list aria-label="Fish selection" class="mb-3">
                          <div *ngFor="let item of bookingDetails.serviceInfo">
                             <mat-chip
                                
                                style="height: auto"                                                                                                                                                                                                            
                                >{{item.service_name}} x {{item.service_qty}}
                             </mat-chip>
                          </div>
                       </mat-chip-list>
                    </div>
                 </div>
              </div>
           </div>
          </div>

           <div class="product_list_yy" *ngIf="bookingDetails.appointment_products">
           <div class="col-md-12" style="padding: 0;">
              <div class="sub_one sub_margin">
                 <div class="sub_one_cont">
        
                    <div class="entity_detail make_text_grey">
                       Products
                    </div>
                 </div>
                 <div class="sub_one_cont main_text">
                    <div class="entity_detail" style="margin-bottom: 0px !important;">
                       <mat-chip-list aria-label="Fish selection" class="mb-3">
                          <div *ngFor="let item of bookingDetails.appointment_products">
                             <mat-chip
                                
                                style="height: auto"                                                                                                                                                                                                            
                                >{{item.product_name}} x {{item.item_qty}}
                             </mat-chip>
                          </div>
                       </mat-chip-list>
                    </div>
                 </div>
              </div>
           </div>
          </div>

          <div class="other_item_list" *ngIf="bookingDetails.custom_items">
           <div class="col-md-12" style="padding: 0;">
            <div class="sub_one sub_margin">
               <div class="sub_one_cont">
               
                  <div class="entity_detail make_text_grey">
                     Other items
                  </div>
               </div>
               <div class="sub_one_cont main_text">
                  <div class="entity_detail" style="margin-bottom: 0px !important;">
                     <mat-chip-list aria-label="Fish selection" class="mb-3">
                        <div *ngFor="let item of bookingDetails.custom_items">
                           <mat-chip
                              
                              style="height: auto"                                                                                                                                                                                                            
                              >{{item.item_name}} x {{item.item_qty}}
                           </mat-chip>
                        </div>
                     </mat-chip-list>
                  </div>
               </div>
            </div>
         </div>
        </div>
          </div>
       </div>


<!-- others section -->
<!-- <div class="service_billing_section" style="padding-bottom: 0px;">
        <div class="row">
          
        </div>
      </div> -->


      <!-- start -->

 


    <!-- <div class="service_billing_section" *ngIf="bookingDetails.member_notes && bookingDetails.member_notes != 'null'">
      <div class="ther_oper">
        <div class="sub_one sub_margin">
           <div class="sub_one_cont">
            
              <div class="entity_detail make_text_grey" style="margin-bottom: 3px !important;">
                 Member notes
              </div>
           </div>
           <div class="sub_one_cont main_text">
              <div class="entity_detail ">
               <p class="membernotes"> {{bookingDetails.member_notes}}</p> 
              </div>
           </div>
        </div>
     </div>
    </div>


    <div class="service_billing_section" *ngIf="bookingDetails.note && bookingDetails.note != 'null'">
    <div class="ther_oper">
      <div class="sub_one sub_margin">
         <div class="sub_one_cont">
         
            <div class="entity_detail make_text_grey" style="margin-bottom: 3px !important;">
               Service provider notes
            </div>
         </div>
         <div class="sub_one_cont main_text">
            <div class="entity_detail" >
              <p class="membernotes">  {{bookingDetails.note}} </p>
            </div>
         </div>
      </div>
   </div>
    </div> -->


    <div class="service_billing_section" style="padding-bottom: 10px !important;">
    <div class="ther_oper">
      <div class="sub_one sub_margin">
         <div class="sub_one_cont">
            <!-- <div>
               <span class="material-icons icon_mat"> receipt_long </span>
            </div> -->
            <div class="entity_detail make_text_grey" style="margin-bottom: 3px !important;">
               Assigned to
            </div>
         </div>
         <div class="sub_one_cont main_text">
            <div class="entity_detail" >
              <p class="membernotes">   {{bookingDetails.employeeName  ? bookingDetails.employeeName : (bookingDetails.employee_name ? bookingDetails.employee_name : '---') }} </p>
            </div>
         </div>
      </div>
   </div>
    </div>





      <!-- <div class="bookinght_sectiokl">
        <div class="row">

          

          



      
        
        </div>
     </div> -->

<!-- sesh -->
     </div>
     <!-- new design end -->
     <!--  -->
   
  </div>
</mat-dialog-content>